import { UserTableRow } from '@/modules/administration/components/UserTableRow';
import type { Role } from '@/modules/auth/roles';
import type { CompanyApi } from '@/modules/companies/types';
import { Skeleton } from '@/modules/ui/components/skeleton/Skeleton';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/modules/ui/components/table/Table';
import type { UserApi } from '@/modules/users/types';

interface UserTableProps {
  users: UserApi[] | undefined;
  companies: CompanyApi[] | undefined;
  isLoading: boolean;
  onAssignTenant: (user: UserApi) => void;
  onAssignRole: (user: UserApi) => void;
  onManageTenants: (user: UserApi) => void;
  onManageRoles: (user: UserApi) => void;
  onRemoveTenant: (userId: string, tenantId: string) => void;
  onRemoveRole: (userId: string, role: Role) => void;
  onSetDefaultTenant: (userId: string, tenantId: string) => void;
}

export const UserTable = ({
  users,
  companies,
  isLoading,
  onAssignTenant,
  onAssignRole,
  onManageTenants,
  onManageRoles,
  onRemoveTenant,
  onRemoveRole,
  onSetDefaultTenant,
}: UserTableProps) => {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Name</TableHead>
          <TableHead>Email</TableHead>
          <TableHead>Tenants</TableHead>
          <TableHead>Roles</TableHead>
          <TableHead>Actions</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {isLoading ? (
          Array.from({ length: 5 }).map((_, i) => (
            <TableRow key={i}>
              <TableCell>
                <Skeleton className="h-4 w-[150px]" />
              </TableCell>
              <TableCell>
                <Skeleton className="h-4 w-[200px]" />
              </TableCell>
              <TableCell>
                <Skeleton className="h-4 w-[100px]" />
              </TableCell>
              <TableCell>
                <Skeleton className="h-4 w-[100px]" />
              </TableCell>
              <TableCell>
                <Skeleton className="h-8 w-[100px]" />
              </TableCell>
            </TableRow>
          ))
        ) : users?.length === 0 ? (
          <TableRow>
            <TableCell colSpan={5} className="h-24 text-center">
              No users found.
            </TableCell>
          </TableRow>
        ) : (
          users?.map((user) => (
            <UserTableRow
              key={user.id}
              user={user}
              companies={companies}
              onAssignTenant={onAssignTenant}
              onAssignRole={onAssignRole}
              onManageTenants={onManageTenants}
              onManageRoles={onManageRoles}
              onRemoveTenant={onRemoveTenant}
              onRemoveRole={onRemoveRole}
              onSetDefaultTenant={onSetDefaultTenant}
            />
          ))
        )}
      </TableBody>
    </Table>
  );
};
